module.exports = __webpack_public_path__ + "static/media/camera.9bab166b.svg";